import React from 'react';
import AccountOptionItem from './AccountOptionItem';

export default function OrderHistoryOption({ navigation, toggleAccountModal }) {
  const openOrderHistory = () => {
    toggleAccountModal();
    navigation.navigate('OrdersHistory');
  };

  return (
    <AccountOptionItem label='Order History' handlePress={openOrderHistory} />
  );
}
